export enum PokerPage {
	CreateGame = "create-game",
	JoinGame = "join-game",
	Game = "game",
}
